/**
 * 2024.04 카카오 주소 검색 API 이용
 */
import React from "react";
import { useDaumPostcodePopup } from "react-daum-postcode";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { resolveI18n } from "../services/Translation";

export default function AddressSearch({ setAddrXY }) {
  const { t, i18n } = useTranslation();
  const open = useDaumPostcodePopup(
    `https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js`
  );
  const handleComplete = (data) => {
    // let fullAddress = data.address
    // let extraAddress = ''
    // if (data.addressType === 'R') {
    //     if (data.bname !== '') {
    //         extraAddress += data.bname
    //     }
    //     if (data.buildingName !== '') {
    //         extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
    //     }
    //     fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    // }
    // console.log(fullAddress)

    // console.log(data)
    const jibunAddress = data.jibunAddress;
    if (jibunAddress) {
      sessionStorage.setItem("kakao", "true");
      axios
        .get(
          `https://dapi.kakao.com/v2/local/search/address.json?query=${jibunAddress}`
        )
        .then((res) => {
          const { address_name, x, y } = res.data.documents[0];
          setAddrXY(address_name, x, y);
          sessionStorage.removeItem("kakao");
        })
        .catch((err) => {
          console.log(err);
          sessionStorage.removeItem("kakao");
        });
    } else {
      alert("정확한 위치 표시를 위해 지번 주소를 선택해 주시기 바랍니다.");
    }
  };
  const handleClick = () => {
    open({ onComplete: handleComplete });
  };

  return (
    <button
      type="button"
      className={`btn primary ${resolveI18n({ i18n, ko: "w120", en: "w150", vi: "w150" })} ml-10`}
      onClick={handleClick}
    >
      {t("key57")}
    </button>
  );
}
